module.exports = __webpack_public_path__ + "img/1004.95790a2f.jpg";